import FourZeroFourPage from './FourZeroFourPage';

export default FourZeroFourPage;
